import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import { useNavigate, useParams } from "react-router-dom";
import { Formik, Field, ErrorMessage, Form as FormikForm } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { resetPassword } from "../Redux/Actions/auth";
import { toast } from "react-toastify";

const validationSchema = Yup.object({
  newPassword: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .required("New password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
    .required("Confirm password is required"),
});

export default function ResetPassword() {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const { token } = useParams()

  const handleSubmit = (values) => {

    let data = {
      token,
      password: values.newPassword
    }

    dispatch(resetPassword(data)).then((res) => {
      if (res?.payload?.status == 200) {
        toast.success(res?.payload?.message)
        navigate("/")
      } else {
        toast.error(res?.payload?.message)
      }
    })

  };


  return (
    <div>
      <Container fluid>
        <Row>
          <Col lg={12}>
            <div className="logo">
              <img src={require("../Assets/Images/Logo.svg").default} />
            </div>
          </Col>
        </Row>
      </Container>
      <Container fluid className="">
        <div className="row  sign-banner-part">
          <Col lg={8} className="p-0">
            <div className="reset-banner-img"></div>
          </Col>
          <Col lg={4}>
            <div className="right-banner-part">
              <div className="login-cmn-box">
                <div className="login-box-inner-wrap">
                  <h2>Reset Passwoard 🔒</h2>
                  <p className="mb-0">
                    Your new password must be different from previously used
                    passwords
                  </p>
                  <Formik
                    initialValues={{
                      newPassword: "",
                      confirmPassword: "",
                    }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ handleSubmit }) => (
                      <FormikForm onSubmit={handleSubmit}>
                        <div className="form-set">
                          {/* New Password Field */}
                          <Form.Group className="mb-3" controlId="formBasicNewPassword">
                            <Form.Label>New Password</Form.Label>
                            <Field
                              name="newPassword"
                              type="password"
                              className="form-control"
                              placeholder="New Password"
                            />
                            <ErrorMessage
                              name="newPassword"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>

                          {/* Confirm Password Field */}
                          <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                            <Form.Label>Confirm Password</Form.Label>
                            <Field
                              name="confirmPassword"
                              type="password"
                              className="form-control"
                              placeholder="Confirm Password"
                            />
                            <ErrorMessage
                              name="confirmPassword"
                              component="div"
                              className="text-danger"
                            />
                          </Form.Group>
                        </div>

                        {/* Submit Button */}
                        <button type="submit" className="submit forgot-btn">
                          Set New Password
                        </button>
                        <div className="back-link-ad">
                          <Link to="/">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="7"
                              height="13"
                              viewBox="0 0 7 13"
                              fill="none"
                            >
                              <path
                                d="M6 1.5L1 6.5L6 11.5"
                                stroke="#E43F6F"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            Back to login
                          </Link>
                        </div>
                      </FormikForm>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </Col>
        </div>
      </Container>
    </div>
  );
}
